import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Warm empty state: icon medallion + display-type title + friendly line, with an
 * optional action. Replaces bare one-line "Nothing here" text so empty screens
 * still feel like Chortle.
 */
export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  icon: string;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="empty-icon" aria-hidden="true">
        <ion-icon name={icon} />
      </div>
      <div className="empty-title">{title}</div>
      {children && <div>{children}</div>}
      {action}
    </div>
  );
}

/** Shared "you need a household first" empty state used across feature pages. */
export function NoHouseholdEmpty() {
  return (
    <EmptyState
      icon="home-outline"
      title="No household yet"
      action={
        <Link to="/household" className="btn btn-primary">
          Set up your household
        </Link>
      }
    >
      Chortle starts with a household — create one, or join your family&apos;s.
    </EmptyState>
  );
}
